const DashboardError: React.FC<{ error?: string | null }> = ({ error }) => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6">
      <div className="p-3 text-md text-red-700">
        {"Something went wrong. Please try again later."}
      </div>
    </div>
  );
};

export default DashboardError;
